import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { AiCreationCanvas } from '@/features/app-shell/canvases/ai-creation-canvas'

export const Route = createFileRoute('/app/ai-create')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AiCreatePage,
})

function AiCreatePage() {
  return <AppShell activePath="/app/ai-create"><AiCreationCanvas /></AppShell>
}
